module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "addbumBtn",
    on: {
      "click": function($event) {
        _vm.dialogVisible = true
      }
    }
  }, [_c('i', {
    staticClass: "el-icon-plus"
  })]), _vm._v(" "), _c('el-dialog', {
    staticClass: "dialog",
    attrs: {
      "title": "添加资源",
      "visible": _vm.dialogVisible,
      "center": true,
      "width": "1000px"
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogVisible = $event
      }
    }
  }, [_c('div', [_c('el-form', {
    attrs: {
      "inline": true,
      "model": _vm.formFuzzy,
      "label-width": "80px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "资源名称:"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "180px"
    },
    attrs: {
      "placeholder": "输入商品名称"
    },
    model: {
      value: (_vm.formFuzzy.name),
      callback: function($$v) {
        _vm.$set(_vm.formFuzzy, "name", $$v)
      },
      expression: "formFuzzy.name"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "专辑类型:"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "220px"
    },
    attrs: {
      "clearable": ""
    },
    model: {
      value: (_vm.formFuzzy.layerType),
      callback: function($$v) {
        _vm.$set(_vm.formFuzzy, "layerType", $$v)
      },
      expression: "formFuzzy.layerType"
    }
  }, _vm._l((_vm.layerTypeList), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    staticStyle: {
      "background-color": "#009e7d"
    },
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.onQuery
    }
  }, [_vm._v("搜索")])], 1)], 1), _vm._v(" "), (_vm.label == '音频资源') ? _c('p', {
    staticStyle: {
      "color": "red",
      "font-weight": "bold",
      "margin-left": "80px"
    }
  }, [_vm._v("*听力熊T3，T4系列不支持多层专辑显示")]) : _c('br'), _vm._v(" "), _c('el-table', {
    ref: "multipleTable",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.queryData,
      "stripe": "",
      "border": "",
      "tooltip-effect": "dark",
      "header-cell-style": _vm.rowClass
    },
    on: {
      "selection-change": _vm.handleSelectionChange
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "selection",
      "width": "50"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "id",
      "label": "资源id",
      "align": "center",
      "min-width": "120"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "name",
      "label": "资源名称",
      "align": "center",
      "width": "180"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "lable",
      "label": "类型",
      "align": "center",
      "min-width": "100"
    }
  }, [_vm._v("\n          " + _vm._s(_vm.label))]), _vm._v(" "), (_vm.label == '音频资源') ? _c('el-table-column', {
    attrs: {
      "prop": "layerType",
      "label": "专辑类型",
      "align": "center",
      "min-width": "100"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.layerType == 2) ? _c('span', [_vm._v("多层专辑")]) : _vm._e(), _vm._v(" "), (scope.row.layerType == 1) ? _c('span', [_vm._v("单层专辑")]) : _vm._e()]
      }
    }], null, false, 3865414012)
  }) : _vm._e(), _vm._v(" "), (_vm.label == '音频资源') ? _c('el-table-column', {
    attrs: {
      "prop": "res_count",
      "label": "数量",
      "align": "center",
      "min-width": "100"
    }
  }) : _c('el-table-column', {
    attrs: {
      "prop": "count",
      "label": "数量",
      "align": "center",
      "min-width": "100"
    }
  }), _vm._v(" "), (_vm.typeValue == 1 || _vm.typeValue == 2) ? _c('el-table-column', {
    attrs: {
      "prop": "enabled",
      "label": "状态",
      "align": "center",
      "min-width": "100"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.enabled) ? _c('el-tag', {
          attrs: {
            "type": "success"
          }
        }, [_vm._v("已上架")]) : _c('el-tag', {
          attrs: {
            "type": "danger"
          }
        }, [_vm._v("已下架")])]
      }
    }], null, false, 780320960)
  }) : _vm._e(), _vm._v(" "), (_vm.typeValue == 3) ? _c('el-table-column', {
    attrs: {
      "prop": "enabled",
      "label": "状态",
      "align": "center",
      "min-width": "100"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.status == 1) ? _c('el-tag', {
          attrs: {
            "type": "success"
          }
        }, [_vm._v("已上架")]) : _vm._e(), _vm._v(" "), (scope.row.status == 0) ? _c('el-tag', {
          attrs: {
            "type": "danger"
          }
        }, [_vm._v("已下架")]) : _vm._e()]
      }
    }], null, false, 2464679688)
  }) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "pagination-box"
  }, [_c('el-pagination', {
    attrs: {
      "current-page": _vm.queryParams.page,
      "page-sizes": [20, 50, 100],
      "page-size": _vm.queryParams.pageSize,
      "layout": "total, sizes, prev, pager, next, jumper",
      "total": _vm.pageTotal
    },
    on: {
      "size-change": _vm.handleSizeChange,
      "current-change": _vm.handleCurrentChange,
      "update:currentPage": function($event) {
        return _vm.$set(_vm.queryParams, "page", $event)
      },
      "update:current-page": function($event) {
        return _vm.$set(_vm.queryParams, "page", $event)
      }
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.dialogVisible = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "background-color": "#009e7d"
    },
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.dialogConfirm
    }
  }, [_vm._v("确定")])], 1)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2e7c8b7e","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/operation/addClassResource.vue
// module id = 671
// module chunks = 1